(function () {
  'use strict';
  class StickyAtcVariantB {
    constructor() {
      this.isUpdatingFromSticky = false;
      this.atcOutOfView = false;
      this.lastScrollY = window.scrollY;

      try {
        this.initElements();
        if (!this.bar) {
          throw new Error('Sticky ATC V2: bar element not found');
        }
        this.initFromUrl();
        this.initDesktopPosition();
        this.initScrollTrigger();
        this.initVariantSync();
        this.initStickySelectSync();
        this.initFormSubmission();
      } catch (err) {
        console.error('Sticky ATC V2 init failed:', err);
        if (document.readyState !== 'complete') {
          window.addEventListener('load', () => {
            try {
              this.initElements();
              if (this.bar) {
                this.initFromUrl();
                this.initDesktopPosition();
                this.initScrollTrigger();
                this.initVariantSync();
                this.initStickySelectSync();
                this.initFormSubmission();
              }
            } catch (e) {
              console.error('Sticky ATC V2 retry failed:', e);
            }
          });
        }
      }
    }

    /* ── Element references ── */

    initElements() {
      this.bar = document.getElementById('stickyAtcVariantB');
      this.thumb = this.bar?.querySelector('[data-sticky-thumb]');
      this.swatchDot = this.bar?.querySelector('[data-sticky-swatch-dot]');
      this.colorLabel = this.bar?.querySelector('[data-sticky-color-label]');
      this.colorWrap = this.bar?.querySelector('[data-sticky-color]');
      this.currentPriceEl = this.bar?.querySelector('[data-sticky-current-price]');
      this.comparePriceEl = this.bar?.querySelector('[data-sticky-compare-price]');
      this.form = this.bar?.querySelector('[data-sticky-form]');
      this.select = this.bar?.querySelector('[data-variant-select="sticky-v2"]');
      this.submitBtn = this.bar?.querySelector('[data-sticky-submit]');
      this.btnText = this.bar?.querySelector('[data-sticky-btn-text]');

      this.mainAtcBtn = document.querySelector('.product-form__buttons');
      // USP strip (Afterpay / free shipping / money-back guarantee) rendered
      // just below the main ATC button via the 'smallxtx' block.
      this.uspStrip = document.querySelector('.icon-container');
      this.variantRadios = document.querySelector('variant-radios');
      this.isMobile = window.matchMedia('(max-width: 749px)');

      this.variants = this.parseVariants();
      this.colorHexMap = this.buildColorHexMap();
    }

    parseVariants() {
      try {
        var el = document.querySelector('[data-json-type="product-variants"]');
        return el ? JSON.parse(el.textContent) : [];
      } catch (e) {
        return [];
      }
    }

    buildColorHexMap() {
      var map = {};
      document.querySelectorAll('[data-swatch-color]').forEach(function (label) {
        var handle = label.getAttribute('data-swatch-color');
        var bg = label.style.backgroundColor;
        if (handle && bg) map[handle] = bg;
      });
      return map;
    }

    /* ── Build select options from variant JSON + set URL variant ── */

    initFromUrl() {
      if (!this.select) return;

      // Populate select from variant JSON data on the page
      var placeholder = this.select.querySelector('option[value=""]');
      this.select.innerHTML = '';
      if (placeholder) this.select.appendChild(placeholder);

      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        if (!v.available) opt.disabled = true;
        this.select.appendChild(opt);
      }

      // Set selection from URL ?variant= param
      var params = new URLSearchParams(window.location.search);
      var variantId = params.get('variant');
      if (variantId) {
        this.select.value = variantId;
        var variant = this.variants.find(function (v) {
          return String(v.id) === variantId;
        });
        if (variant) {
          this.updateThumbnail(variant, variant.option1);
          this.updateColor(variant.option1);
          this.updatePrice(variant);
          this.updateButton(variant);
        }
      }
    }

    /* ── Desktop: position bar to align with product__info-wrapper ── */

    initDesktopPosition() {
      // Desktop positioning handled by CSS — no JS needed
    }

    /* ── Scroll trigger ── */

    initScrollTrigger() {
      var self = this;

      if (this.isMobile.matches) {
        // Mobile: observe the main ATC button — show sticky whenever it's
        // not visible at all (scrolled above OR below the viewport)
        this.initMobileTrigger();
      } else {
        // Desktop: observe variant-radios area (scrolled above only)
        this.initDesktopTrigger();
      }

      // Re-init on breakpoint change
      this.isMobile.addEventListener('change', function () {
        if (self.isMobile.matches) {
          self.initMobileTrigger();
        } else {
          self.initDesktopTrigger();
        }
      });
    }

    initMobileTrigger() {
      var self = this;
      // Prefer the USP strip (Afterpay / shipping / guarantee icons) that
      // sits below the main ATC button — the bar should only appear once
      // that strip has scrolled out of view too, not as soon as the button
      // itself disappears. Falls back to the button on products where the
      // strip block isn't rendered.
      var triggerEl = this.uspStrip || this.mainAtcBtn;
      if (!triggerEl) return;

      // Disconnect previous observers if any
      if (this.mobileObserver) this.mobileObserver.disconnect();
      if (this.titleObserver) this.titleObserver.disconnect();
      if (this.desktopObserver) this.desktopObserver.disconnect();

      // Reset state — recompute from the observers below
      this.atcOutOfView = false;
      // Default to "title out of the way" so we don't deadlock the bar
      // on products where no title element is found.
      this.titleOutOfView = true;

      this.mobileObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // Trigger element not visible at all (above or below viewport). The
        // rootMargin shrinks the observed area to the bottom half of the
        // screen, so "above" exits fire as soon as the element has scrolled
        // into the top half — sooner than waiting for it to fully disappear.
        self.atcOutOfView = !entry.isIntersecting;
        self.updateMobileVisibility();
      }, { threshold: 0, rootMargin: '-50% 0px 0px 0px' });
      this.mobileObserver.observe(triggerEl);

      // Gate the reveal on the page's product title: don't show the bar while
      // the <h1> is still on screen, otherwise it slides up over the title on
      // initial load (the main ATC is below the fold from the start, so the
      // ATC-only trigger would fire immediately). The bar appears the moment
      // the title scrolls above the viewport — still "asap", never covering it.
      var titleEl = this.findVisibleTitle();
      if (titleEl) {
        this.titleOutOfView = false;
        this.titleObserver = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          self.titleOutOfView =
            !entry.isIntersecting && entry.boundingClientRect.top < 0;
          self.updateMobileVisibility();
        }, { threshold: 0 });
        this.titleObserver.observe(titleEl);
      }
    }

    // Show on mobile only once both the main ATC button AND the product title
    // are out of view, so the bar never overlaps the title.
    updateMobileVisibility() {
      this.toggleBar(this.atcOutOfView && this.titleOutOfView);
    }

    // Find the product title <h1> that is actually rendered for the current
    // breakpoint (the markup carries A/B-test variants, only one is visible).
    findVisibleTitle() {
      var titles = document.querySelectorAll('.product__title h1');
      for (var i = 0; i < titles.length; i++) {
        if (titles[i].offsetParent !== null) return titles[i];
      }
      return titles[0] || null;
    }

    initDesktopTrigger() {
      var self = this;
      var triggerEl = this.variantRadios || this.mainAtcBtn;
      if (!triggerEl) return;

      // Disconnect previous observers if any
      if (this.desktopObserver) this.desktopObserver.disconnect();
      if (this.mobileObserver) this.mobileObserver.disconnect();
      // The title gate is mobile-only — drop it when switching to desktop.
      if (this.titleObserver) this.titleObserver.disconnect();

      this.desktopObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // Only when scrolled above the viewport. The rootMargin shrinks the
        // observed area to the bottom half of the screen, so this fires as
        // soon as the trigger element has scrolled into the top half —
        // sooner than waiting for it to fully disappear. The boundingClientRect
        // check keeps this "above" only (excludes the not-yet-reached case
        // where the element still sits below the fold).
        self.atcOutOfView = !entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight / 2;
        self.toggleBar(self.atcOutOfView);
      }, { threshold: 0, rootMargin: '-50% 0px 0px 0px' });

      this.desktopObserver.observe(triggerEl);
    }

    toggleBar(show) {
      if (!this.bar) return;
      this.bar.classList.toggle('is-visible', show);
      this.bar.setAttribute('aria-hidden', String(!show));
    }

    /* ── Variant sync: main form → sticky bar ── */

    initVariantSync() {
      var self = this;

      if (this.variantRadios) {
        this.variantRadios.addEventListener('change', function () {
          if (self.isUpdatingFromSticky) return;
          requestAnimationFrame(function () {
            self.syncFromMain();
          });
        });
      }

      // Watch for variant data updates from Section Rendering API
      var variantDataEl = document.querySelector('[data-json-type="product-variants"]');
      if (variantDataEl) {
        new MutationObserver(function () {
          self.variants = self.parseVariants();
          self.rebuildSelect();
          self.syncFromMain();
        }).observe(variantDataEl, { childList: true, characterData: true, subtree: true });
      }

      // Sync main ATC button state
      if (this.mainAtcBtn) {
        new MutationObserver(function () {
          self.syncButtonFromMain();
        }).observe(this.mainAtcBtn, { attributes: true, childList: true, subtree: true });
      }

      // Initial sync
      this.syncFromMain();
    }

    syncFromMain() {
      if (!this.variantRadios) return;

      var colorInput = this.variantRadios.querySelector(
        'input[name="Color"]:checked, input[name="Colour"]:checked'
      );
      var sizeInput = this.variantRadios.querySelector('input[name="Size"]:checked');

      var color = colorInput ? colorInput.value : null;
      var size = sizeInput ? sizeInput.value : null;

      // Find matching variant
      var variant = null;
      if (color && size) {
        variant = this.variants.find(function (v) {
          return v.option1 === color && v.option2 === size;
        });
      } else if (color && !size) {
        // Color-only product (no size option)
        variant = this.variants.find(function (v) {
          return v.option1 === color && !v.option2;
        });
      }

      this.updateThumbnail(variant, color);
      this.updateColor(color);
      this.updatePrice(variant);
      this.updateSelect(variant);
      this.updateButton(variant);
    }

    /* ── Sticky select sync: sticky → main form ── */

    initStickySelectSync() {
      if (!this.select) return;
      var self = this;

      this.select.addEventListener('change', function (e) {
        var selectedVariantId = e.target.value;
        if (!selectedVariantId) return;

        self.isUpdatingFromSticky = true;

        var variant = self.variants.find(function (v) {
          return String(v.id) === selectedVariantId;
        });

        if (variant && self.variantRadios) {
          // Click matching color radio
          if (variant.option1) {
            var colorInputs = self.variantRadios.querySelectorAll(
              'input[name="Color"], input[name="Colour"]'
            );
            colorInputs.forEach(function (input) {
              if (input.value === variant.option1) input.click();
            });
          }
          // Click matching size radio
          if (variant.option2) {
            var sizeInputs = self.variantRadios.querySelectorAll('input[name="Size"]');
            sizeInputs.forEach(function (input) {
              if (input.value === variant.option2) input.click();
            });
          }
        }

        // Update sticky UI
        self.updateThumbnail(variant, variant?.option1);
        self.updateColor(variant?.option1);
        self.updatePrice(variant);
        self.updateButton(variant);

        setTimeout(function () {
          self.isUpdatingFromSticky = false;
        }, 300);
      });
    }

    rebuildSelect() {
      if (!this.select) return;
      var currentValue = this.select.value;
      var placeholder = this.select.querySelector('option[value=""]');

      this.select.innerHTML = '';
      if (placeholder) this.select.appendChild(placeholder);

      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        if (!v.available) opt.disabled = true;
        if (String(v.id) === currentValue) opt.selected = true;
        this.select.appendChild(opt);
      }
    }

    /* ── Dynamic UI updates ── */

    updateThumbnail(variant, color) {
      if (!this.thumb) return;

      if (variant && variant.featured_image && variant.featured_image.src) {
        this.thumb.src = this.resizeImageUrl(variant.featured_image.src, 150);
        return;
      }

      if (color) {
        var activeSlide = document.querySelector('.product__media-item.is-active img');
        if (activeSlide && activeSlide.src) {
          this.thumb.src = this.resizeImageUrl(activeSlide.src, 150);
        }
      }
    }

    resizeImageUrl(url, width) {
      if (!url) return url;
      if (url.includes('width=')) {
        return url.replace(/width=\d+/, 'width=' + width);
      }
      var sep = url.includes('?') ? '&' : '?';
      return url + sep + 'width=' + width;
    }

    updateColor(color) {
      if (!color || !this.colorWrap) return;

      var handle = color.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

      if (this.colorLabel) {
        this.colorLabel.textContent = color;
      }

      if (this.swatchDot) {
        var hex = this.colorHexMap[handle];
        if (hex) {
          this.swatchDot.style.backgroundColor = hex;
        }
      }
    }

    updatePrice(variant) {
      if (!variant) return;

      if (this.currentPriceEl) {
        this.currentPriceEl.textContent = this.formatMoney(variant.price);
      }

      if (this.comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.comparePriceEl.textContent = this.formatMoney(variant.compare_at_price);
          this.comparePriceEl.style.display = '';
        } else {
          this.comparePriceEl.style.display = 'none';
        }
      }
    }

    formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(
          cents,
          (window.theme && window.theme.moneyFormat) || '${{amount}}'
        );
      }
      return '$' + (cents / 100).toFixed(2);
    }

    updateSelect(variant) {
      if (!this.select || !variant) return;
      this.select.value = variant.id;
    }

    updateButton(variant) {
      if (!this.submitBtn || !this.btnText) return;

      // Always show "ADD TO CART" — disable when unavailable
      this.btnText.textContent = 'ADD TO CART';

      if (!variant || !variant.available) {
        this.submitBtn.disabled = true;
      } else {
        this.submitBtn.disabled = false;
      }
    }

    syncButtonFromMain() {
      if (!this.submitBtn || !this.mainAtcBtn) return;

      var mainBtn = this.mainAtcBtn.querySelector('button[name="add"], button.product-form__submit');
      if (!mainBtn) return;

      // Only sync disabled state — always keep "ADD TO CART" text
      this.submitBtn.disabled = mainBtn.disabled;
    }

    /* ── Form submission ── */

    initFormSubmission() {
      var self = this;

      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (self.submitBtn.disabled) return;

        // Check if a variant is actually selected
        if (self.select && (!self.select.value || self.select.value === '')) {
          // No variant picked — flash the select to draw attention
          self.select.focus();
          return;
        }

        self.handleSubmit();
      });
    }

    async handleSubmit() {
      try {
        this.submitBtn.setAttribute('aria-busy', 'true');
        this.submitBtn.disabled = true;

        var formData = new FormData(this.form);

        // Pre-order detection
        var variantSelects = document.querySelector('variant-selects, variant-radios');
        if (variantSelects && variantSelects.currentVariant) {
          var cv = variantSelects.currentVariant;
          var isPreOrder = (cv.metafields && (cv.metafields.show_preorder === 'true' || cv.metafields.show_preorder === true))
            && (cv.inventory_quantity || 0) < 1
            && cv.inventory_policy && cv.inventory_policy.includes('continue');
          if (isPreOrder) {
            formData.append('properties[_is_preorder]', 'true');
          }
        }

        // Cart drawer sections
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          var sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
        }

        var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        });

        var data = await response.json();

        if (response.ok) {
          if (cartDrawer) {
            if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(data);
            }
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          }
        } else {
          throw new Error(data.description || 'Error adding to cart');
        }
      } catch (err) {
        this.showError(err.message);
      } finally {
        this.submitBtn.removeAttribute('aria-busy');
        this.submitBtn.disabled = false;
      }
    }

    showError(message) {
      var el = document.createElement('div');
      el.className = 'sticky-atc-v2__error';
      el.textContent = message;
      this.bar.appendChild(el);
      setTimeout(function () { el.remove(); }, 3000);
    }
  }

  /* ── Initialize ── */

  function init() {
    try {
      new StickyAtcVariantB();
    } catch (err) {
      console.error('Sticky ATC V2:', err);
    }
  }

  // Dormant until activated — see product-ab-tests.js
  var activated = false;
  window.enableStickyAtcVariantB = function () {
    if (activated) return;
    activated = true;

    document.documentElement.setAttribute('data-sticky-atc-variant', 'b');

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  };

  // If something already set the attribute directly (e.g. Visually or a QA
  // script) before this script ran, honor it instead of staying dormant.
  if (document.documentElement.getAttribute('data-sticky-atc-variant') === 'b') {
    window.enableStickyAtcVariantB();
  } else {
    // The attribute is often set *after* this deferred script has already
    // run its one-time check above — e.g. pasted into devtools during QA,
    // or Visually.io injecting its experience code post-load. Without this
    // observer, a late attribute never reaches init() and the bar stays
    // permanently dormant even though the attribute is visibly "b" in the DOM.
    var attrObserver = new MutationObserver(function () {
      if (document.documentElement.getAttribute('data-sticky-atc-variant') === 'b') {
        window.enableStickyAtcVariantB();
        attrObserver.disconnect();
      }
    });
    attrObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-sticky-atc-variant']
    });
  }
})();
